import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { inject } from 'vue';
import NavBar from '@/components/ui/NavBar.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const $aegis = inject('$aegis');
    // check current environment is supported TRTC or not
    // TRTC.checkSystemRequirements().then((checkResult) => {
    //   if (!checkResult.result) {
    //     console.log('checkResult', checkResult.result, 'checkDetail', checkResult.detail);
    //     ElMessage({ message: 'Your browser does not supported TRTC!', type: 'error' });
    //     // window.location.href = 'https://web.sdk.qcloud.com/trtc/webrtc/demo/detect/index.html';
    //   }
    // });
    $aegis.reportEvent({
      name: 'loaded',
      ext1: 'loaded-success',
      ext2: 'webrtcQuickDemoVue3'
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(NavBar), _createVNode(_component_router_view)], 64);
    };
  }
});